import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.9 8.3q.15-.3 0-.6c-.4-.5-.8-1-1.1-1.4-.7-.8-1.4-1.5-2.2-2.1l1.9-1.9c.2-.2.2-.5 0-.7s-.5-.2-.7 0l-2 2c-.3-.2-.6-.3-.9-.5-1.9-1-4.1-.9-5.9.2-.3.1-.5.3-.6.4l-2-2c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l1.8 1.9C2.2 5.2 1 6.4.1 7.7q-.15.3 0 .6c.9 1.3 2.1 2.5 3.4 3.5l-1.9 1.9c-.2.2-.2.5 0 .7s.5.2.7 0l2-2c1.1.7 2.4 1.1 3.7 1.2 1.1 0 2.2-.3 3.1-.9l.5-.3 2 2c.2.2.5.2.7 0s.2-.5 0-.7l-1.8-1.8c1.3-1.1 2.5-2.3 3.4-3.6M5.3 4.2c1.5-.9 3.4-.9 5-.2l.6.3-.8.8c-1.2-1-3-1.1-4.3-.1l-.7-.6c.1-.1.2-.1.2-.2m1.6 3.4c0 .1-.1.2-.1.3s.1.3.1.4l-1 1.1c-.7-.8-.7-2-.1-2.9zm-.4-1.8c.9-.6 2-.5 2.8.1L8.3 7c-.1-.1-.3-.1-.4-.1h-.2zm1.3 3.1c.2 0 .3 0 .4-.1L9.3 10c-.8.5-1.8.6-2.7.1zm1-.8v-.3L10 6.7c.5.8.5 1.8 0 2.6zm-4.6 3C3 10.2 2 9.2 1.1 8 2 6.8 3 5.8 4.2 4.9l.9.9c-1 1.3-1 3.1.1 4.3zm6.5.7c-.8.4-1.7.7-2.7.7s-2-.3-2.9-.9l.8-.8c1.2.9 2.9.8 4.1-.1l.9.9zm1.1-.7L10.7 10c.9-1.2.9-2.8.1-4l1-1c.8.6 1.6 1.2 2.2 2 .3.3.6.7.9 1.1-.9 1.1-1.9 2.1-3.1 3" />
  </svg>
);
const SvgEyeLineNext = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="eye-line-next" {...props} />;
export default SvgEyeLineNext;
